/**
 * Gateway IPFS milik BigBangX.
 * Domain lama (.io) sudah dimatikan, jadi semua URL gambar lama yang
 * tersimpan di database harus dipetakan ke domain baru (.org) saat dirender.
 */
export const IPFS_GATEWAY = "https://ipfs.bigbangx.org";

const LEGACY_IPFS_HOSTS = [
    "ipfs.bigbangx.io",
];

/**
 * Normalisasi URL gambar sebelum dipakai di `<img src=...>`:
 * - host IPFS lama (.io) -> gateway baru (.org)
 * - skema `ipfs://<cid>` -> URL gateway
 * Nilai lain (path lokal, blob:, data:, URL eksternal) dikembalikan apa adanya.
 */
export function resolveImageUrl<T extends string | undefined | null>(url: T): T {
    if (!url || typeof url !== "string") return url;

    if (url.startsWith("ipfs://")) {
        return `${IPFS_GATEWAY}/ipfs/${url.slice("ipfs://".length).replace(/^ipfs\//, "")}` as T;
    }

    for (const host of LEGACY_IPFS_HOSTS) {
        const match = url.match(new RegExp(`^https?://${host.replace(/\./g, "\\.")}(/.*)?$`, "i"));
        if (match) return `${IPFS_GATEWAY}${match[1] ?? ""}` as T;
    }

    return url;
}
